<div class="card">
    <div class="section-header">
        <h2 class="section-title">{{ 'profileEducation.education' | translate }}</h2>
        <button class="add-btn" (click)="openAddModal()" *ngIf="mode=='edit'">{{ 'profileEducation.add' | translate
            }}</button>
    </div>

    <!-- Education List -->
    <div class="edu-list" *ngIf="education && education.length > 0">
        <div class="edu-item" *ngFor="let edu of education; let i = index; let last = last" [class.last]="last">
            <!-- Graduation cap icon -->
            <div class="edu-icon" [style.background]="edu.color + '18'" [style.color]="edu.color"
                [style.border-color]="edu.color + '30'">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z" />
                </svg>
            </div>

            <div class="edu-content">
                <div class="edu-top">
                    <div>
                        <h3 class="edu-school">{{ edu.university }}</h3>
                        <p class="edu-meta">{{ edu.degree }} in {{ edu.major }}</p>
                        <p class="edu-meta" *ngIf="edu.grade">GPA: {{ edu.grade }}</p>
                        <p class="edu-meta">{{ getPeriod(edu) }}</p>
                    </div>
                    <div class="edu-actions" *ngIf="mode=='edit'">
                        <button class="icon-btn" [title]="'profileAbout.edit' | translate"
                            (click)="openEditModal(edu, i)">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                            </svg>
                        </button>
                        <button class="icon-btn icon-btn-delete" [title]="'profileEducation.delete' | translate"
                            (click)="deleteEducation(i)">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                <path d="M10 11v6"></path>
                                <path d="M14 11v6"></path>
                                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <p class="edu-description" *ngIf="edu.details">{{ edu.details }}</p>
            </div>
        </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!education || education.length === 0 && mode=='edit'">
        <p class="empty-text">
            {{ 'profileEducation.addEducationalBackground' | translate }}
        </p>
    </div>
    <div *ngIf="!education || education.length === 0 && mode=='view'">
        <p class="empty-text">
            {{ 'profileEducation.addEducationalcomapnyBackground' | translate }}
        </p>
    </div>
</div>

<!-- Add / Edit Modal — outside .card -->
<div class="modal-overlay" *ngIf="isModalOpen && mode=='edit'" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">

        <button class="close-btn" (click)="closeModal()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>

        <div class="modal-header">
            <h3 class="modal-title">{{ isEditing ? ('profileEducation.editEducation' | translate) :
                ('profileEducation.addEducation' | translate) }}</h3>
        </div>

        <div class="modal-body">
            <form [formGroup]="eduForm">

                <!-- Row 1: University and Degree -->
                <div class="form-row">
                    <div class="form-group">
                        <label for="university">{{ 'profileEducation.university' | translate }} <span
                                class="required">*</span></label>
                        <input id="university" type="text" formControlName="university" class="form-input"
                            placeholder="e.g. University of California" />
                        <span class="field-error"
                            *ngIf="eduForm.get('university')?.invalid && eduForm.get('university')?.touched">
                            Required
                        </span>
                    </div>
                    <div class="form-group">
                        <label for="degree">{{ 'profileEducation.degree' | translate }} <span
                                class="required">*</span></label>
                        <input id="degree" type="text" formControlName="degree" class="form-input"
                            placeholder="e.g. Bachelor of Science" />
                        <span class="field-error"
                            *ngIf="eduForm.get('degree')?.invalid && eduForm.get('degree')?.touched">
                            Required
                        </span>
                    </div>
                </div>

                <!-- Row 2: Major -->
                <div class="form-row">
                    <div class="form-group full-width">
                        <label for="major">{{ 'profileEducation.majorFieldOfStudy' | translate }} <span
                                class="required">*</span></label>
                        <input id="major" type="text" formControlName="major" class="form-input"
                            placeholder="e.g. Computer Science" />
                        <span class="field-error"
                            *ngIf="eduForm.get('major')?.invalid && eduForm.get('major')?.touched">
                            Required
                        </span>
                    </div>
                </div>

                <!-- Row 3: Grade -->
                <div class="form-row">
                    <div class="form-group full-width">
                        <label for="grade">{{ 'profileEducation.gpaGradeOptional' | translate }}</label>
                        <input id="grade" type="text" formControlName="grade" class="form-input"
                            placeholder="e.g. 3.8 or A+" />
                    </div>
                </div>

                <!-- Row 4: Start and End Date -->
                <div class="form-row">
                    <div class="form-group">
                        <label for="startDate">{{ 'profileEducation.startDate' | translate }} <span
                                class="required">*</span></label>
                        <input id="startDate" type="date" formControlName="startDate" class="form-input" />
                        <span class="field-error"
                            *ngIf="eduForm.get('startDate')?.invalid && eduForm.get('startDate')?.touched">
                            Required
                        </span>
                    </div>
                    <div class="form-group">
                        <label for="endDate">{{ 'profileEducation.endDate' | translate }}</label>
                        <input id="endDate" type="date" formControlName="endDate" class="form-input"
                            [class.disabled]="isCurrent" [attr.disabled]="isCurrent ? true : null" />
                    </div>
                </div>

                <!-- Currently studying checkbox -->
                <div class="form-group full-width checkbox-row">
                    <label class="checkbox-label">
                        <input type="checkbox" formControlName="isCurrent" class="checkbox-input" />
                        <span>{{ 'profileEducation.currentlyStudyingHere' | translate }}</span>
                    </label>
                </div>

                <!-- Details -->
                <div class="form-group full-width">
                    <label for="details">{{ 'profileEducation.detailsOptional' | translate }}</label>
                    <textarea id="details" formControlName="details" class="form-textarea"
                        placeholder="Add any additional information (e.g., Minor in Mathematics, Honors, Scholarships, etc.)"
                        rows="3"></textarea>
                </div>

            </form>

            <div class="modal-actions">
                <button class="btn btn-cancel" (click)="closeModal()">{{ 'profileEducation.cancel' | translate
                    }}</button>
                <button class="btn btn-save" (click)="saveEducation()" [disabled]="isSaving">
                    <span *ngIf="!isSaving">{{ isEditing ? ('profileEducation.saveChanges' | translate) :
                        ('profileEducation.addEducation' | translate) }}</span>
                    <span *ngIf="isSaving">{{ 'profileEducation.saving' | translate }}</span>
                </button>
            </div>
        </div>

    </div>
</div>